import { useCallback, useMemo } from 'react';
import { rfpOneUseCase } from '@/container/Client/Rfp/One/UseCase/RfpOneUseCase';
import { isNonNumericFalsyValue } from '@/utils/checkValue/number';
/**
 * データの取得, タブ管理, コンポーネントに渡す値に変更する
 */
export const useRfpClientOneNegotiatePage = (args) => {
    const { auth, negotiateList, negotiateOne, profile, rfp, unreadCounts } = args;
    /**
     * ユーザーのデータ propsに渡す用
     */
    const myUser = useMemo(() => ({
        clientId: `${profile.id}`,
        firstName: profile.information.firstName,
        isShowDetailPage: false,
        lastName: profile.information.lastName,
        professionalId: '', // 企業アカウントのため false 固定
    }), [profile]);
    /**
     * 詳細のデータを props に渡す用に変更
     */
    const getNegotiateData = useCallback((negotiate) => {
        if (!negotiate) {
            return negotiate;
        }
        const chatItems = negotiate.messages.map((m) => {
            const user = {
                clientId: isNonNumericFalsyValue(m.client_id) ? '' : `${m.client_id}`,
                firstName: m.first_name,
                imageSrc: m.image_src,
                isRetired: m.is_retired,
                isShowDetailPage: m.has_professional_detail_page,
                lastName: m.last_name,
                professionalId: isNonNumericFalsyValue(m.professional_id)
                    ? ''
                    : `${m.professional_id}`,
                professionalType: m.professional_type,
            };
            const message = {
                isBox: !m.is_same_organization,
                message: m.description,
                messageId: m.id,
                time: new Date(m.published_at),
                unread: m.is_unread,
            };
            return { id: m.id, message, user };
        });
        return {
            chatItems,
            draftMessage: negotiate.draft_message
                ? {
                    id: negotiate.draft_message.id,
                    message: negotiate.draft_message.description,
                }
                : null,
            hasUnRead: negotiate.unread_count > 0,
            negotiateId: negotiate.id,
            status: negotiate.status,
            user: myUser,
        };
    }, [myUser]);
    // 一覧のデータを props に渡す用に変更
    const items = useMemo(() => negotiateList.map((item) => ({
        companyName: item.organization_name,
        hasUnAnswer: item.has_unanswered_negotiate_messages,
        id: item.id,
        unReadCount: unreadCounts[item.id],
    })), [negotiateList, unreadCounts]);
    // 詳細のデータを props に渡す用に変更
    const { budgetNegotiate, endDateNegotiate, startDateNegotiate } = useMemo(() => ({
        budgetNegotiate: getNegotiateData(negotiateOne.budget_negotiate),
        endDateNegotiate: getNegotiateData(negotiateOne.end_date_negotiate),
        startDateNegotiate: getNegotiateData(negotiateOne.start_date_negotiate),
    }), [getNegotiateData, negotiateOne]);
    // メンバーに関する情報 取得
    const { isCanUpdateMember, isMemberAdmin, members } = rfpOneUseCase.useMemberInfo(rfp, profile, auth);
    return {
        budgetNegotiate,
        endDateNegotiate,
        isCanUpdateMember,
        isMemberAdmin,
        items,
        members,
        startDateNegotiate,
    };
};
